export const LOCALIZED_PRICE_ERROR = 'Price point is not localized';

export const TRANSLATE_MOCK_MAP: Record<string, string> = {
  'footer.privacy': 'Privacy Policy',
  'footer.termsAndConditions': 'Terms and Conditions',
  'footer.support': 'Support',
  'footer.cookieSettings': 'Cookie Settings'
};
